export enum FeatureState {
  Initial = "Initial",
  Loading = "Loading",
  Success = "Success",
  Error = "Error"
}

export enum ChargingStatus {
  NEW = "NEW",
  CREDIT_CARD_VALIDATED = "CREDIT_CARD_VALIDATED",
  STARTED = "STARTED",
  STOPPED = "STOPPED",
  INVALID = "INVALID",
  PENDING = "PENDING",
  START_COMMAND_ACCEPTED = "START_COMMAND_ACCEPTED"
}
